import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Convo } from '../../models/convo';
import { Observable, of, catchError, finalize } from 'rxjs';
import { ConvoComponent } from '../convo/convo.component';
import { CommonModule } from '@angular/common';
import { PillComponent } from '../../../lib/components/pill/pill.component';
import { ObjectType } from '../../../shared/models/object.model';
import { SpinnerComponent } from 'src/lib/components/spinner/spinner.component';
import { EscapeKeyService } from '../../../core/services/escape-key.service';

// Dialog component for both mobile and desktop
@Component({
  selector: 'motn-moti-chat-dialog',
  templateUrl: './moti-chat.component.html',
  styleUrl: './moti-chat.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ConvoComponent,
    PillComponent,
    SpinnerComponent,
  ],
})
export class MotiChatDialogComponent implements OnInit, OnDestroy {
  @Input() objectName!: string;
  @Input() objectId!: string;
  @Input() topicId?: string;
  @Input() convo?: Convo;
  @Input() objectType!: string;
  @Input() convo$?: Observable<Convo>;

  @Output() closeRequested = new EventEmitter<void>();

  readonly ObjectType = ObjectType;
  displayConvo$: Observable<Convo | null> = of(null);
  isLoading = true;
  private unregisterEsc = () => {};

  constructor(private escapeKeyService: EscapeKeyService) {}

  ngOnInit(): void {
    this.displayConvo$ = this.getConvoObservable().pipe(
      finalize(() => this.isLoading = false),
      catchError(error => {
        console.error('Failed to load conversation:', error);
        return of(null);
      })
    );
    this.unregisterEsc = this.escapeKeyService.register(() => this.closeDialog());
  }

  private getConvoObservable(): Observable<Convo | null> {
    if (this.convo) {
      return of(this.convo);
    }
    return this.convo$ || of(null);
  }

  onConvoReady(): void {
    this.isLoading = false;
  }

  closeDialog(): void {
    this.unregisterEsc();
    this.closeRequested.emit();
  }

  ngOnDestroy(): void {
    this.unregisterEsc();
  }
}
